var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},_vm._l((_vm.statuses),function(status){return _c('v-step',{key:status.text,attrs:{"value":status.text,"text":status.text,"is-active":status.isActive}},[_vm._v("\n    "+_vm._s(status)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }